import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { API_BASE } from "../../AppConfig";
import { BaseURL } from "../../components/Common";
import Icon from "@material-ui/core/Icon";
import { Palette } from "../../AppConfig";
import * as APP from "../../redux_store/appState";
import SegmentedButtonGroup from "../../components/SegmentedButtonGroup";
import LayersIcon from "@material-ui/icons/Layers";
import BSL_ToggleButton from "../../components/BSL_ToggleButton";
import Slider from "@material-ui/core/Slider";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import * as BABYLON from "babylonjs";
import * as PAPER from "./PaperFunctions";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import { uploadDocument } from "../../redux_store/jobState";
import IconButton from "@material-ui/core/IconButton";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";

const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: "90px",
        paddingLeft: "10px",
        width: "100%",
        overflow: "auto",
    },
    sectionHeader: {
        font: "24px " + theme.typography.fontFamily,
        fontWeight: "400",
        color: Palette.Control.DarkGrey,
        verticalAlign: "text-top",
        width: "180px",
        paddingTop: "24px",
        paddingBottom: "4px",
        whiteSpace: "nowrap",
    },
    layer_row: {
        display: "flex",
        alignItems: "center",
        background: Palette.Control.LightGrey,
    },
    layer_header: {
        display: "flex",
        alignItems: "center",
        flex: 1,
        fontSize: "11pt",
        fontFamily: theme.typography.fontFamily,
        fontWeight: "200",
        paddingLeft: "10px",
    },
    iconRoot: {
        textAlign: "center",
        display: "flex",
        alignItems: "center",
    },
    imageIcon: {
        height: "100%",
    },
    layer_icon: {
        color: "#888888",
        marginRight: "5px",
    },
    label: {
        cursor: "pointer",
        minWidth: "180px",
        marginLeft: "20px",
        flex: "1",
        font: "16px " + theme.typography.fontFamily,
        color: Palette.Control.DarkGrey,
        padding: "4px 0px",
        display: "flex",
        alignItems: "center",
    },
    label_clickable: {
        cursor: "pointer",
        minWidth: "180px",
        marginLeft: "20px",
        flex: "1",
        alignItems: "center",
        font: "16px " + theme.typography.fontFamily,
        color: Palette.Control.DarkGrey,
        padding: "4px 0px",
        display: "flex",
        "&:hover": {
            background: "#33333311",
        },
    },
    sliderContainer: {
        width: "100%",
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap",
    },
    slider: {
        width: "77%",
        marginLeft: "20px",
        '& .MuiSlider-markLabel[data-index="0"]': {
            font: "11px " + theme.typography.fontFamily,
            color: Palette.Control.PaleBlue,
            transform: "translateX(0%)",
        },
        '& .MuiSlider-markLabel[data-index="1"]': {
            font: "11px " + theme.typography.fontFamily,
            color: Palette.Control.PaleBlue,
            transform: "translateX(-100%)",
        },
    },
    slider_mark: {
        color: Palette.Control.PaleBlue,
    },
    iconButton: {
        fontSize: "16px",
        fontFamily: theme.typography.fontFamily,
        fontWeight: "400",
        color: "#002D62",
        marginTop: "-4px",
        borderRadius: "0%",
    },
}));

const marks = [
    {
        value: 0,
        label: "Low (fast)",
    },
    {
        value: 100,
        label: "High (slow)",
    },
];

export default function DisplayOptions3D(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const designer2D = useSelector((state) => state.app.designer.designer2D);
    const designer3D = useSelector((state) => state.app.designer.designer3D);
    const threeDMode = useSelector((state) => state.app.designer[APP.THREED_MODE]);
    const threeDImages = useSelector((state) => state?.job?.QuoteParameters?.DOCUMENTS?.["3DScreenShots"]);
    const threeDImageCount = useSelector((state) => state?.job?.QuoteParameters?.DOCUMENTS?.["3DScreenShots"].length);
    const job_id = useSelector((state) => state?.job?.id);
    const job = useSelector((state) => state?.job);
    const carportMode = job?.DesignParameters?.CarportMode === 1;

    const [quality_slider, setquality_slider] = React.useState(null);
    const [sun_angle_slider_x, setsun_angle_slider_x] = React.useState(null);
    const [sun_angle_slider_y, setsun_angle_slider_y] = React.useState(null);
    const [fontsizeSlider, setfontsizeSlider] = React.useState(null);

    const [imageSet, setimageSet] = React.useState([]);
    const [photoIndex, setphotoIndex] = React.useState(0);
    const [lightBoxIsOpen, setlightBoxIsOpen] = React.useState(false);
    const [lightBoxImages, setLightBoxImages] = React.useState([]);

    const ATTACHMENT_MESH_MODE = designer3D[APP.ATTACHMENT_MESH_MODE];
    const ROOFSHEET__MESH_MODE = designer3D[APP.ROOFSHEET__MESH_MODE];
    const BEAM_AND_POST_MESH_MODE = designer3D[APP.BEAM_AND_POST_MESH_MODE];
    const FOOTINGS_MESH_MODE = designer3D[APP.FOOTINGS_MESH_MODE];
    const GUTTERS_AND_FLASHING_MESH_MODE = designer3D[APP.GUTTERS_AND_FLASHING_MESH_MODE];
    const VERANDAH_EDGE_LINE_MODE = designer3D[APP.VERANDAH_EDGE_LINE_MODE];
    const BACKGROUND_MODE = designer3D[APP.BACKGROUND_MODE];
    const RENDERQUALITYFACTOR = designer3D[APP.RENDERQUALITYFACTOR];
    const SUN_ANGLE = designer3D[APP.SUN_ANGLE];
    const SUN_ANGLE_Y = designer3D[APP.SUN_ANGLE_Y];
    const FONT_SIZE = designer2D[APP.FONT_SIZE];
    const SHOW_BEAM_LENGTHS = designer2D[APP.SHOW_BEAM_LENGTHS];
    const SHOW_POST_DIMENSIONS = designer2D[APP.SHOW_POST_DIMENSIONS];
    const DRAW_FULL_LAYOUT = designer2D[APP.DRAW_FULL_LAYOUT];

    const screenshotEndPoint = API_BASE() + "document/" + job_id + "/";

    React.useEffect(() => {
        if (job_id && threeDImages) {
            const loadImageWithRetries = (imageSrc, retries = 3) => {
                return new Promise((resolve) => {
                    const attemptLoad = (attemptsLeft) => {
                        const img = new Image();
                        img.src = imageSrc;
                        img.onload = () => {
                            resolve({
                                url: img.src,
                                thumb: img.src,
                            });
                        };
                        img.onerror = () => {
                            if (attemptsLeft > 0) {
                                setTimeout(() => attemptLoad(attemptsLeft - 1), 500);
                            } else {
                                resolve(null);
                            }
                        };
                    };
                    attemptLoad(retries);
                });
            };

            const loadImages = async () => {
                const loadedImages = await Promise.all(
                    threeDImages.map((image) => loadImageWithRetries(`${screenshotEndPoint}${image}`, 3))
                );

                setLightBoxImages(loadedImages.filter(Boolean));
            };

            loadImages();
        }
    }, [threeDImageCount, job_id]);

    const openLightBox = (index, images) => (event) => {
        setimageSet(images);
        setphotoIndex(index);
        setlightBoxIsOpen(true);
        event.stopPropagation();
        return false;
    };

    const takeScreenshot = () => {
        var scene = window._scene_data.scene;
        var camera = window._scene_data.camera;
        window._scene_data.dispatch = dispatch;
        window._scene_data.uploadDocument = uploadDocument;
        BABYLON.Tools.CreateScreenshot(scene.getEngine(), camera, { width: 1920, height: 980 }, function (data) {
            let filename = Date.now();
            window._scene_data.dispatch(window._scene_data.uploadDocument("3DScreenShots", filename + ".png", data));
        });
    };

    let layers = [];
    layers.push({ header: "Attachment Layer", key: APP.ATTACHMENT_MESH_MODE, value: ATTACHMENT_MESH_MODE });
    layers.push({ header: "Roof Sheet Layer", key: APP.ROOFSHEET__MESH_MODE, value: ROOFSHEET__MESH_MODE });
    layers.push({ header: "Beams and Posts Layer", key: APP.BEAM_AND_POST_MESH_MODE, value: BEAM_AND_POST_MESH_MODE });
    layers.push({
        header: "Gutters & Downpipes Layer",
        key: APP.GUTTERS_AND_FLASHING_MESH_MODE,
        value: GUTTERS_AND_FLASHING_MESH_MODE,
    });
    layers.push({ header: "Footings Layer", key: APP.FOOTINGS_MESH_MODE, value: FOOTINGS_MESH_MODE });

    let layer_rows = [];

    for (let row_data of layers) {
        layer_rows.push(
            <div key={row_data.header} className={classes.layer_row}>
                <div className={classes.layer_header}>
                    <LayersIcon className={classes.layer_icon} /> {row_data.header}
                </div>
                <SegmentedButtonGroup
                    value={row_data.value}
                    style={{
                        marginRight: "5px",
                    }}
                    ButtonGroupStyle={{
                        padding: "0px",
                        border: "none",
                    }}
                    ButtonStyle={{
                        padding: "0px",
                    }}
                    items={[
                        {
                            Key: "Render",
                            Display: (
                                <Icon className={classes.iconRoot}>
                                    <img className={classes.imageIcon} src={BaseURL("/images/mesh-render.svg")} />
                                </Icon>
                            ),
                        },
                        {
                            Key: "Mesh",
                            Display: (
                                <Icon className={classes.iconRoot}>
                                    <img className={classes.imageIcon} src={BaseURL("/images/mesh-mesh.png")} />
                                </Icon>
                            ),
                        },
                        {
                            Key: "Hidden",
                            Display: (
                                <Icon className={classes.iconRoot}>
                                    <img className={classes.imageIcon} src={BaseURL("/images/mesh-hidden.svg")} />
                                </Icon>
                            ),
                        },
                    ]}
                    onChange={(e, val) => {
                        dispatch(APP.update3DDesigner(row_data.key, val));
                    }}
                />
            </div>
        );
    }
    return (
        <div className={classes.root}>
            <div style={{ width: "100%", textAlign: "right" }}>
                <IconButton
                    className={classes.iconButton}
                    classes={{ root: classes.iconButtonRoot }}
                    onClick={(e) => {
                        dispatch(APP.toggleDesigner(APP.SHOW_DISPLAY_OPTIONS));
                    }}
                >
                    <ChevronRightIcon className={classes.icon} />
                </IconButton>
            </div>

            <div className={classes.sectionHeader} style={{ marginTop: "-40px" }}>
                Layers
            </div>
            {layer_rows}

            {!carportMode && (
                <React.Fragment>
                    <div className={classes.sectionHeader}>3D Display Options</div>

                    <BSL_ToggleButton
                        label="Show Edge Lines"
                        checked={VERANDAH_EDGE_LINE_MODE}
                        onChange={() => {
                            dispatch(APP.toggle3DDesigner(APP.VERANDAH_EDGE_LINE_MODE));
                        }}
                    />
                    <BSL_ToggleButton
                        label="Show Environment"
                        checked={BACKGROUND_MODE !== "Grid"}
                        onChange={() =>
                            dispatch(
                                APP.update3DDesigner(APP.BACKGROUND_MODE, BACKGROUND_MODE === "Grid" ? "Plain" : "Grid")
                            )
                        }
                    />

                    <div className={classes.label}>3D Render Quality %</div>

                    <div className={classes.sliderContainer}>
                        <Slider
                            classes={{
                                root: classes.slider,
                                markLabel: classes.slider_mark,
                                markLabelActive: classes.slider_mark,
                            }}
                            track={false}
                            value={quality_slider ? quality_slider : RENDERQUALITYFACTOR * 10}
                            min={1}
                            max={100}
                            marks={marks}
                            step={1}
                            onChange={(e, value) => {
                                setquality_slider(value);
                            }}
                            onChangeCommitted={(e, value) => {
                                setquality_slider(null);
                                dispatch(APP.update3DDesigner(APP.RENDERQUALITYFACTOR, value / 10));
                            }}
                            valueLabelDisplay="auto"
                        />
                    </div>
                    <div className={classes.label}>Sun Position</div>
                    <div className={classes.sliderContainer}>
                        X:{" "}
                        <Slider
                            classes={{
                                root: classes.slider,
                                markLabel: classes.slider_mark,
                            }}
                            track={false}
                            value={sun_angle_slider_x ? sun_angle_slider_x : SUN_ANGLE}
                            min={-3}
                            max={3}
                            step={0.1}
                            onChange={(e, value) => {
                                setsun_angle_slider_x(value);
                                window._scene_data.direction_light.direction.x = value;
                                window._scene_data.direction_light.position.x = -1000 * value;
                                if (window._scene_data.shadowGenerator)
                                    window._scene_data.shadowGenerator.getShadowMap().refreshRate = 24;
                            }}
                            onChangeCommitted={(e, value) => {
                                if (window._scene_data.shadowGenerator)
                                    window._scene_data.shadowGenerator.getShadowMap().refreshRate = 3;
                                dispatch(APP.update3DDesigner(APP.SUN_ANGLE, value));
                            }}
                            valueLabelDisplay="auto"
                        />
                    </div>

                    <div className={classes.sliderContainer}>
                        Y:{" "}
                        <Slider
                            classes={{
                                root: classes.slider,
                                markLabel: classes.slider_mark,
                            }}
                            track={false}
                            value={sun_angle_slider_y ? sun_angle_slider_y : SUN_ANGLE_Y}
                            min={-3}
                            max={3}
                            step={0.1}
                            onChange={(e, value) => {
                                setsun_angle_slider_y(value);
                                window._scene_data.direction_light.direction.z = value;
                                window._scene_data.direction_light.position.z = -1000 * value;
                                if (window._scene_data.shadowGenerator)
                                    window._scene_data.shadowGenerator.getShadowMap().refreshRate = 24;
                            }}
                            onChangeCommitted={(e, value) => {
                                if (window._scene_data.shadowGenerator)
                                    window._scene_data.shadowGenerator.getShadowMap().refreshRate = 3;
                                dispatch(APP.update3DDesigner(APP.SUN_ANGLE_Y, value));
                            }}
                            valueLabelDisplay="auto"
                        />
                    </div>
                </React.Fragment>
            )}

            <div className={classes.sectionHeader}>2D Display Options</div>

            <div className={classes.label}>Text Size</div>
            <div className={classes.sliderContainer}>
                <Slider
                    classes={{
                        root: classes.slider,
                        markLabel: classes.slider_mark,
                        markLabelActive: classes.slider_mark,
                    }}
                    track={false}
                    value={fontsizeSlider ? fontsizeSlider : FONT_SIZE}
                    min={1}
                    max={300}
                    marks={[
                        {
                            value: 1,
                            label: "Small",
                        },
                        {
                            value: 300,
                            label: "Large",
                        },
                    ]}
                    step={1}
                    onChange={(e, value) => {
                        setfontsizeSlider(value);
                        PAPER.UpdateAllText(value);
                    }}
                    onChangeCommitted={(e, value) => {
                        setfontsizeSlider(null);
                        dispatch(APP.update2DDesigner(APP.FONT_SIZE, value));
                    }}
                    valueLabelDisplay="auto"
                />
            </div>

            <BSL_ToggleButton
                label="Show Beam Lengths"
                checked={SHOW_BEAM_LENGTHS}
                onChange={() => {
                    dispatch(APP.toggle2DDesigner(APP.SHOW_BEAM_LENGTHS));
                }}
            />

            <BSL_ToggleButton
                label="Show Post Dimensions"
                checked={SHOW_POST_DIMENSIONS}
                onChange={() => {
                    dispatch(APP.toggle2DDesigner(APP.SHOW_POST_DIMENSIONS));
                }}
            />

            <BSL_ToggleButton
                label="Show Full Layout in Shape / Dimensions"
                checked={DRAW_FULL_LAYOUT}
                onChange={() => {
                    dispatch(APP.toggle2DDesigner(APP.DRAW_FULL_LAYOUT));
                }}
            />

            {threeDMode && (
                <>
                    <div className={classes.sectionHeader}>Save Model Screenshots</div>

                    <div
                        className={classes.label_clickable}
                        onClick={() => {
                            takeScreenshot();
                        }}
                    >
                        <CameraAltIcon style={{ marginRight: "10px" }} />
                        <span>Take Screenshot</span>
                    </div>

                    {lightBoxImages.length > 0 && (
                        <div style={{ position: "relative", width: "300px", height: "auto" }}>
                            {lightBoxImages.map((image, index) => (
                                <img
                                    key={image.url || index}
                                    src={image.url}
                                    width="300px"
                                    style={{
                                        position: index > 0 ? "absolute" : "relative",
                                        top: `${10 * index}px`,
                                        left: `${10 * index}px`,
                                        zIndex: lightBoxImages.length - index,
                                        opacity: Math.max(0, 1 - index * 0.2),
                                        cursor: "pointer",
                                        transition: "all 0.3s ease",
                                    }}
                                    onClick={openLightBox(index, lightBoxImages)}
                                />
                            ))}
                        </div>
                    )}
                </>
            )}

            {lightBoxIsOpen && (
                <Lightbox
                    mainSrc={imageSet[photoIndex].url}
                    nextSrc={imageSet[(photoIndex + 1) % imageSet.length].thumb}
                    prevSrc={imageSet[(photoIndex + imageSet.length - 1) % imageSet.length].thumb}
                    onCloseRequest={() => setlightBoxIsOpen(false)}
                    onMovePrevRequest={() => setphotoIndex((photoIndex + imageSet.length - 1) % imageSet.length)}
                    onMoveNextRequest={() => setphotoIndex((photoIndex + 1) % imageSet.length)}
                    reactModalStyle={{ overlay: { zIndex: 9999 } }}
                />
            )}
        </div>
    );
}
